var _path, _path2, _rect, _path3, _rect2, _path4, _rect3, _path5, _rect4, _polygon, _polygon2, _rect5, _polygon3, _polygon4, _polygon5, _rect6, _polygon6, _polygon7, _polygon8, _rect7, _polygon9, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _polygon10, _polygon11, _rect20, _polygon12, _polygon13, _polygon14, _polygon15, _rect21, _polygon16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 50 50",
    viewBox: "0 0 50 50",
    id: "qr-code",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37,1h-5.3l0.4,1.1c0.3,1-0.4,1.9-1.4,1.9H19.3c-0.9,0-1.7-0.9-1.4-1.9L18.3,1H13c-1.7,0-3,1.3-3,3c0,0.2,0,3.5,0,42 c0,1.7,1.3,3,3,3h24c1.7,0,3-1.3,3-3V4C40,2.3,38.7,1,37,1z M25,47.4c-1.2,0-2.3-1-2.3-2.3s1-2.3,2.3-2.3c1.2,0,2.3,1,2.3,2.3 S26.2,47.4,25,47.4z M39,40.9H11V6.5h28V40.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3 3h11.4c.3 0 .5-.3.4-.6L30.6 1H19.4l-.5 1.4C18.8 2.7 19 3 19.3 3zM20.1 12.7h-6v6h6V12.7zM19.2 17.9h-4.3v-4.3h4.3V17.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.6,
    height: 2.6,
    x: 15.8,
    y: 14.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9,12.7h-6v6h6V12.7z M35.1,17.9h-4.3v-4.3h4.3V17.9z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.6,
    height: 2.6,
    x: 31.6,
    y: 14.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20,28.6h-6v6h6V28.6z M19.2,33.8h-4.3v-4.3h4.3V33.8z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.6,
    height: 2.6,
    x: 15.7,
    y: 30.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30,34.7h6v-6h-6V34.7z M30.8,29.5h4.3v4.3h-4.3V29.5z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.6,
    height: 2.6,
    x: 31.7,
    y: 30.4
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "25.8 13.9 25.2 13.9 25.2 14.6 26.5 14.6 26.5 15.2 28.1 15.2 28.1 13.8 27.5 13.8 27.5 14.6 26.9 14.6 26.9 13.9 26.5 13.9 26.5 13.3 27.6 13.3 27.6 12.7 25.1 12.7 25.1 13.3 25.8 13.3"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "24.5 17.7 25.1 17.7 25.1 17.7 25.6 17.7 25.6 17 25.1 17 25.1 15.2 24.5 15.2 24.5 17 24 17 24 17.7 24.5 17.7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 0.7,
    height: 0.6,
    x: 23.1,
    y: 15.2
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "22.5 13.3 23.6 13.3 23.6 12.7 21.9 12.7 21.9 14.4 22.5 14.4"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "26.5 32.8 25.2 32.8 25.2 33.4 25.8 33.4 25.8 34 25.1 34 25.1 34.7 27.6 34.7 27.6 34 26.5 34 26.5 33.4 26.9 33.4 26.9 32.8 27.5 32.8 27.5 33.6 28.1 33.6 28.1 32.2 26.5 32.2"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "25.1 32.2 25.1 30.3 25.6 30.3 25.6 29.7 25.1 29.7 25.1 29.7 24.5 29.7 24.5 29.7 24 29.7 24 30.3 24.5 30.3 24.5 32.2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 0.7,
    height: 0.6,
    x: 23.1,
    y: 31.5
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "22.5 33 21.9 33 21.9 34.7 23.6 34.7 23.6 34 22.5 34"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.3 24.5 34.8 24.5 34.8 23.9 34.1 23.9 34.1 25.2 33.5 25.2 33.5 26.8 34.9 26.8 34.9 26.1 34.1 26.1 34.1 25.6 34.8 25.6 34.8 25.2 35.3 25.2 35.3 26.3 36 26.3 36 23.8 35.3 23.8"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "31 22.7 31 23.1 31 23.1 31 23.8 31 23.8 31 24.3 31.6 24.3 31.6 23.8 33.5 23.8 33.5 23.1 31.6 23.1 31.6 22.7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 0.6,
    height: 0.7,
    x: 32.9,
    y: 21.8
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "34.3 21.2 35.4 21.2 35.4 22.3 36 22.3 36 20.6 34.3 20.6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 0.6,
    height: 0.7,
    x: 27.5,
    y: 18.9
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 0.6,
    height: 0.7,
    x: 28.1,
    y: 19.6
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 0.6,
    height: 0.7,
    x: 28.7,
    y: 20.3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 0.6,
    height: 0.7,
    x: 21.9,
    y: 18.9
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 0.6,
    height: 0.7,
    x: 21.3,
    y: 19.6
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 0.6,
    height: 0.7,
    x: 20.7,
    y: 20.3
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 0.6,
    height: 0.7,
    x: 27.5,
    y: 27.8
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 0.6,
    height: 0.7,
    x: 28.1,
    y: 27.1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 0.6,
    height: 0.7,
    x: 28.7,
    y: 26.5
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 0.6,
    height: 0.7,
    x: 21.9,
    y: 27.8
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 0.6,
    height: 0.7,
    x: 21.3,
    y: 27.1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 0.6,
    height: 0.7,
    x: 20.7,
    y: 26.5
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "22.3 24.1 22.3 24.8 24.9 24.8 24.9 24.1 24.1 24.1 24.1 23.5 24.8 23.5 24.8 22.8 23.5 22.8 23.5 22.2 21.7 22.2 21.7 23.6 22.4 23.6 22.4 22.8 23 22.8 23 23.5 23.5 23.5 23.5 24.1"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "25.6 24.3 25.6 24.3 25.6 24.8 26.3 24.8 26.3 24.3 28.2 24.3 28.2 23.6 26.3 23.6 26.3 23.1 25.6 23.1 25.6 23.6 25.6 23.6"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 0.6,
    height: 0.7,
    x: 25.6,
    y: 21.6
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "24.9 22.5 24.9 20.7 23.1 20.7 23.1 21.3 24.2 21.3 24.2 22.5"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "27.7 24.9 27 24.9 27 26 23.8 26 23.8 26.7 27.7 26.7"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "14.6 25.2 15.2 25.2 15.2 25.6 15.9 25.6 15.9 26.1 15.1 26.1 15.1 26.8 16.5 26.8 16.5 25.2 15.9 25.2 15.9 23.9 15.2 23.9 15.2 24.5 14.6 24.5 14.6 23.8 14 23.8 14 26.3 14.6 26.3"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "19 24.3 19 23.8 19 23.8 19 23.1 19 23.1 19 22.7 18.3 22.7 18.3 23.1 16.5 23.1 16.5 23.8 18.3 23.8 18.3 24.3"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 0.6,
    height: 0.7,
    x: 16.5,
    y: 21.8
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "14.6 21.2 15.7 21.2 15.7 20.6 14 20.6 14 22.3 14.6 22.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.45884edbf1733e4b7872a2f2eafc3a54.svg";
export { ForwardRef as ReactComponent };